import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import camelcaseKeys from 'camelcase-keys'
import Cookies from 'js-cookie'
import snakecaseKeys from 'snakecase-keys'

export const token = Cookies.get('_ac_token')

type UrlType = { [key: string]: string }

const devPort = process.env.DEVELOPMENT_API_PORT || '3001'

// TODO: 環境変数で管理するようにする
export const urls: UrlType = {
  development:
    process.env.NEXT_PUBLIC_API_URL_DEV || `http://127.0.0.1:${devPort}/api`,
  staging:
    process.env.NEXT_PUBLIC_API_URL ||
    'https://app-stg-dot-artcloud-311007.an.r.appspot.com/api',
  production: process.env.NEXT_PUBLIC_API_URL || 'https://api.theartx.app',
}

const env = process.env.NEXT_PUBLIC_NODE_ENV || 'development'
export const baseUrl = urls[env]

export const AXIOS_INSTANCE = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Set token if available
if (token) {
  AXIOS_INSTANCE.defaults.headers.common.Authorization = `Token token=${token}`
}

// Request interceptor: Convert camelCase to snake_case
AXIOS_INSTANCE.interceptors.request.use(
  (config) => {
    if (config.data) {
      config.data = snakecaseKeys(config.data, { deep: true })
    }
    if (config.params) {
      config.params = snakecaseKeys(config.params, { deep: true })
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor: Convert snake_case to camelCase
AXIOS_INSTANCE.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = camelcaseKeys(response.data, { deep: true })
    }
    return response
  },
  (error) => {
    if (error.response && error.response.data) {
      error.response.data = camelcaseKeys(error.response.data, { deep: true })
    }
    return Promise.reject(error)
  },
)

// https://orval.dev/guides/custom-axios
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = axios.CancelToken.source()
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data)

  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled')
  }

  return promise
}

export type ErrorType<Error> = AxiosError<Error>

export type BodyType<BodyData> = BodyData
